// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__dzKkQ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2xfiw"};